import React from "react";
import { Loader } from "tabler-icons-react";

/**
 * Composant d'état de chargement
 */
const LoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center h-64">
      <Loader size={40} className="animate-spin text-primary" />
      <p className="mt-4 text-primary/60">Chargement des informations...</p>
    </div>
  );
};

export default LoadingState;
